import type { EngineUseRow } from "@shared-core/data/manufacturing-setup-types";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../primitives/table";
import { EngineUseBadge } from "./EngineUseBadge";

/**
 * A tabular sub-tab (Operations, Run speeds, Setups & runs, Geometry,
 * Packing, Ink suitability) — each row badged as a whole, since the engine
 * consumes these rows as a unit (e.g. "the run-speed band for this weight"),
 * not field by field. See `EngineUseRow`'s docstring.
 */
export function EngineUseRowTable({
  rows,
  emptyMessage,
}: {
  rows: EngineUseRow[];
  emptyMessage: string;
}) {
  if (rows.length === 0) {
    return (
      <p className="rounded-md border border-dashed border-border p-4 text-center text-sm text-muted-foreground">
        {emptyMessage}
      </p>
    );
  }
  const columnLabels = rows[0].cells.map((c) => c.label);
  return (
    <div className="overflow-x-auto rounded-md border border-border">
      <Table>
        <TableHeader>
          <TableRow>
            {columnLabels.map((label) => (
              <TableHead key={label}>{label}</TableHead>
            ))}
            <TableHead>Engine use</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow key={i}>
              {row.cells.map((cell, j) => (
                <TableCell
                  key={j}
                  className={j === 0 ? "font-medium" : "text-muted-foreground"}
                >
                  {cell.value}
                </TableCell>
              ))}
              <TableCell>
                <EngineUseBadge status={row.status} why={row.why} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
